import ProductFeed from "@/app/shared/ecommerce/shop/product-feed";
import ShopFilters from "@/app/shared/ecommerce/shop/shop-filters";
import FiltersButton from "@/app/shared/filters-button";
import PageHeader from "@/app/shared/page-header";
import { metaObject } from "@/config/site.config";
import routes from "@/routers/routes";

const pageHeader = {
  title: "Shop",
  breadcrumb: [
    {
      name: "Home",
    },
    {
      href: routes.eCommerce.dashboard,
      name: "E-Commerce",
    },
    {
      name: "Shop",
    },
  ],
};

export const metadata = {
  ...metaObject("Shop"),
};

export default function ShopPage() {
  return (
    <>
      <PageHeader title={pageHeader.title} breadcrumb={pageHeader.breadcrumb}>
        <FiltersButton placement="right" modalView={<ShopFilters />} />
      </PageHeader>

      <ProductFeed />
    </>
  );
}
